"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const iconSize = {
    iconSizeXS: 16,
    iconSizeS: 20,
    iconSizeM: 24,
    iconSizeL: 32,
};
const spinnerSize = {
    spinnerSizeS: 24,
    spinnerSizeM: 40,
    spinnerSizeL: 72,
};
const progressSize = {
    progressSizeS: '100px',
    progressSizeM: '240px',
    progressSizeL: '100%',
};
const buttonHeight = {
    buttonHeightSmall: '32px',
    buttonHeightMedium: '40px',
    buttonHeightLarge: '48px',
};
const inputHeight = {
    inputHeightSmall: '32px',
    inputHeightMedium: '40px',
};
exports.default = {
    ...iconSize,
    ...spinnerSize,
    ...progressSize,
    ...buttonHeight,
    ...inputHeight,
};
